import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { DocumentDetails } from 'src/Components/Documents/DocumentDetails';
import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import useFetchDocument from 'src/Hooks/Queries/useFetchDocument';

const ViewDocumentDrawer = () => {
  const { t } = useTranslation();
  const { assetId, fileId } = useParams<{ assetId: string; fileId: string }>();
  const { data } = useFetchDocument(fileId);

  return (
    <AnimatedRoutedDrawer
      title={t('documents.details.title', 'Détail du document')}
      to={`/asset/${assetId}/documents`}
    >
      {() => data && <DocumentDetails file={data} />}
    </AnimatedRoutedDrawer>
  );
};

export default ViewDocumentDrawer;
